<template>
  <div
    :class="[
      'flex w-full gap-2 p-1',
      expanded ? 'justify-center' : 'items-center',
      isHorizontal ? 'flex-row items-center' : 'flex-col'
    ]"
  >
    <NavigationPaneItem
      v-if="showDashboard"
      :id="DASHBOARD_ID"
      label="Dashboard"
      href="/home2"
      :expanded="isMobileNav ? false : !!expanded"
      :isSelected="selectedItem === DASHBOARD_ID"
      :position="isHorizontal ? 'top' : 'left'"
      :isMobileNav="isMobileNav"
      @click="setSelectedItem(DASHBOARD_ID)"
    >
      <template #icon>
        <DashboardIcon />
      </template>
    </NavigationPaneItem>

    <NavigationPaneItem
      v-if="showCoachAI"
      :id="COACH_AI_ID"
      label="Coach AI"
      href="/coach-ai"
      :disabled="true"
      :expanded="isMobileNav ? false : !!expanded"
      :isSelected="selectedItem === COACH_AI_ID"
      :position="isHorizontal ? 'top' : 'left'"
      :isMobileNav="isMobileNav"
      @click="setSelectedItem(COACH_AI_ID)"
    >
      <template #icon>
        <CoachAIIcon />
      </template>
    </NavigationPaneItem>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import NavigationPaneItem from './NavigationPaneItem.vue'
import { COACH_AI_ID, DASHBOARD_ID } from '../constants/navigationPaneDefaults'
import { DashboardIcon, CoachAIIcon } from '@/components/icons'

export default defineComponent({
  name: 'DefaultNavigationItems',
  components: {
    NavigationPaneItem,
    DashboardIcon,
    CoachAIIcon
  },
  props: {
    showDashboard: {
      type: Boolean,
      default: true
    },
    showCoachAI: {
      type: Boolean,
      default: true
    },
    expanded: {
      type: Boolean,
      default: false
    },
    isMobileNav: {
      type: Boolean,
      default: false
    },
    isHorizontal: {
      type: Boolean,
      default: false
    },
    selectedItem: {
      type: String,
      default: undefined
    }
  },
  emits: ['setSelectedItem'],
  setup(props, { emit }) {
    const setSelectedItem = (id: string) => {
      emit('setSelectedItem', id)
    }

    return {
      setSelectedItem,
      DASHBOARD_ID,
      COACH_AI_ID
    }
  }
})
</script>
